import React from 'react';

import EmbedBlock from './Embed';

const propTypes = {

};

const defaultProps = {

};

const SectionEmbedBlock = props => (
    <EmbedBlock {...props} withContainer />
);

SectionEmbedBlock.propTypes = propTypes;
SectionEmbedBlock.defaultProps = defaultProps;

export default SectionEmbedBlock;



// WEBPACK FOOTER //
// ./js/components/blocks/SectionEmbed.jsx